import { useMemo } from 'react';
import { ApolloError } from '@apollo/client';

import { useApiGatewayQuery } from '~hooks';
import { CONTRACTORS } from '~organisms/SelectedContractor/queries';
import {
  Contractor,
  GetContractorsQuery,
  GetContractorsQueryVariables,
} from '~types/appsync.types';

const useContractors = (
  slug?: string,
  skip = false,
): [Contractor[], boolean, ApolloError | undefined] => {
  const { data, loading, error } = useApiGatewayQuery<
    GetContractorsQuery,
    GetContractorsQueryVariables
  >(CONTRACTORS, {
    skip,
    variables: slug
      ? {
          slug,
        }
      : undefined,
  });

  const contractors = useMemo(() => (data?.contractors?.length ? data?.contractors : []), [data]);

  return [contractors, loading, error];
};

export default useContractors;
